import { Cell } from '@/components/ui/shared/Table/Cell';
import { DateCell } from '@/components/ui/shared/Table/cells/DateCell';
import type { HideBelow } from '@/components/ui/shared/Table/types';

export interface TableDateCellProps {
  date?: string | null;
  format?: 'relative' | 'dateTime';
  width?: string;
  hideBelow?: HideBelow;
  className?: string;
}

export function TableDateCell({
  date,
  format,
  width = '90px',
  hideBelow = 'md',
  className
}: TableDateCellProps) {
  return (
    <Cell width={width} align="center" hideBelow={hideBelow} className={className}>
      <DateCell date={date} format={format} />
    </Cell>
  );
}
